// eslint-disable-next-line no-restricted-imports
import {v4 as uuid} from 'uuid'

export default uuid